import { AMPLITUDE_EVENT, createLogSagaWithFn } from '@sonar-software/sonar-analytics';
import { createGetAsyncSlice, GetAction, SagaYieldType } from '@sonar-software/xuder';
import { getSonarObjectsSearch, GetSonarObjectsSearchRequest } from '@api';

const logGetCoreSonarObjectsSearch = createLogSagaWithFn<
	GetAction<'CoreSonarObjectsSearch', GetSonarObjectsSearchRequest>
>((action) => {
	const data = action.data as GetSonarObjectsSearchRequest;

	return {
		data: {
			type: data.queryString
		},
		id: AMPLITUDE_EVENT.SEARCH_MADE
	};
});

export const getCoreSonarObjectsSearchSlice = createGetAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: logGetCoreSonarObjectsSearch,
			type: SagaYieldType.Every
		}
	],
	name: 'CoreSonarObjectsSearch',
	receive: true,
	request: true,
	requestHandler: getSonarObjectsSearch,
	retainDataOnRequest: true
});
